import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
 
import { api } from '../api';

function Banners() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [formData, setFormData] = useState({ description: '', imageUrl: '', redirectUrl: '', enabled: true, displayOrder: 1 });
  const [editForm, setEditForm] = useState({ id: '', description: '', imageUrl: '', redirectUrl: '', enabled: true, displayOrder: 1 });
  const [viewBanner, setViewBanner] = useState(null);
  const tableRef = useRef(null);

  // Removed DataTables integration to avoid DOM conflicts with React rendering

  function handleInputChange(e) { const { name, value, type, checked } = e.target; setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value })); }
  function handleEditInputChange(e) { const { name, value, type, checked } = e.target; setEditForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value })); }
  function resetForm() { setFormData({ description: '', imageUrl: '', redirectUrl: '', enabled: true, displayOrder: 1 }); }
  async function fetchBanners() { setLoading(true); const data = await api.getBanners(); setBanners(Array.isArray(data) ? data : []); setLoading(false); }
  useEffect(() => { fetchBanners(); }, []);
  async function handleAdd(e) {
    e.preventDefault();
    setIsCreating(true);
    const payload = { ...formData, displayOrder: Number(formData.displayOrder) || 1 };
    const res = await api.createBanner(payload);
    setIsCreating(false);
    if (res.ok && res.data) {
      setBanners(prev => [res.data, ...prev]);
      resetForm();
      try { const el = document.getElementById('addBanner'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).hide(); } catch {}
    } else {
      alert(res.message || 'Failed to create banner');
    }
  }
  function openEditModal(b) { setEditForm(b); try { const el = document.getElementById('editBanner'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).show(); } catch {} }
  async function handleUpdate(e) {
    e.preventDefault();
    setIsUpdating(true);
    const payload = { ...editForm, displayOrder: Number(editForm.displayOrder) || 1 };
    const res = await api.updateBanner(editForm.id, payload);
    setIsUpdating(false);
    if (res.ok && res.data) {
      setBanners(prev => prev.map(b => (b.id === editForm.id ? res.data : b)));
      try { const el = document.getElementById('editBanner'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).hide(); } catch {}
    } else {
      alert(res.message || 'Failed to update banner');
    }
  }
  function handleDelete(id) { setBanners(prev => prev.filter(b => b.id !== id)); }
  async function handleUpload(e, isEdit = false) { const files = Array.from(e.target.files || []); if (!files.length) return; setUploading(true); const uploaded = await api.uploadFiles(files); setUploading(false); const first = Array.isArray(uploaded) && uploaded.length ? uploaded[0] : null; if (first?.fileUrl) { if (isEdit) setEditForm(prev => ({ ...prev, imageUrl: first.fileUrl })); else setFormData(prev => ({ ...prev, imageUrl: first.fileUrl })); } else { alert('Upload failed'); } }

  function openViewModal(b) { setViewBanner(b); try { const el = document.getElementById('viewBanner'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).show(); } catch {} }

  return (
    <>
      <Helmet><title>Banners | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Banners</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Promotions</p>
            </div>
            <div>
              <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addBanner">Add Banner</button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  <div className="table-responsive">
                    <table id="banners-table" ref={tableRef} className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Image</th>
                          <th>Description</th>
                          <th>Redirect URL</th>
                          <th>Enabled</th>
                          <th>Order</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {banners.map(b => (
                          <tr key={b.id}>
                            <td>{b.id}</td>
                            <td>{b.imageUrl ? <img src={b.imageUrl} alt="banner" style={{ width: 80, height: 40, objectFit: 'cover' }} /> : '-'}</td>
                            <td className="text-truncate" style={{ maxWidth: 260 }}>{b.description || '-'}</td>
                            <td><a href={b.redirectUrl} target="_blank" rel="noreferrer">{b.redirectUrl}</a></td>
                            <td><span className={`ec-status ${b.enabled ? 'ec-active' : 'ec-inactive'}`}>{b.enabled ? 'Enabled' : 'Disabled'}</span></td>
                            <td>{b.displayOrder}</td>
                            <td>
                              <div className="btn-group mb-1">
                                <button className="btn btn-outline-info" onClick={() => openViewModal(b)}>View</button>
                                <button className="btn btn-outline-success" onClick={() => openEditModal(b)}>Edit</button>
                                <button className="btn btn-outline-danger" onClick={() => handleDelete(b.id)}>Delete</button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Add Banner Modal */}
          <div className="modal fade" id="addBanner" tabIndex="-1" aria-labelledby="addBannerLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="addBannerLabel">Add Banner</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                <form onSubmit={handleAdd}>
                  <div className="mb-3"><label className="form-label" htmlFor="ban-image">Image</label><input id="ban-image" type="file" className="form-control" accept="image/*" onChange={(e) => handleUpload(e, false)} disabled={uploading} /></div>
                  <div className="mb-3"><label className="form-label" htmlFor="ban-description">Description</label><textarea id="ban-description" name="description" className="form-control" value={formData.description} onChange={handleInputChange} /></div>
                  <div className="mb-3"><label className="form-label" htmlFor="ban-redirect">Redirect URL</label><input id="ban-redirect" name="redirectUrl" className="form-control" value={formData.redirectUrl} onChange={handleInputChange} /></div>
                  <div className="row">
                    <div className="col-md-6 mb-3"><label className="form-label" htmlFor="ban-order">Display Order</label><input id="ban-order" name="displayOrder" type="number" min="1" className="form-control" value={formData.displayOrder} onChange={handleInputChange} /></div>
                    <div className="col-md-6 mb-3 d-flex align-items-end"><div className="form-check"><input id="ban-enabled" name="enabled" type="checkbox" className="form-check-input" checked={!!formData.enabled} onChange={handleInputChange} /><label className="form-check-label" htmlFor="ban-enabled">Enabled</label></div></div>
                  </div>
                  <div className="d-flex justify-content-end gap-2"><button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={isCreating}>Cancel</button><button type="submit" className="btn btn-primary" disabled={uploading || isCreating}>{isCreating ? 'Adding...' : 'Add'}</button></div>
                </form>
              </div>
            </div></div>
          </div>

          {/* Edit Banner Modal */}
          <div className="modal fade" id="editBanner" tabIndex="-1" aria-labelledby="editBannerLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="editBannerLabel">Edit Banner</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                <form onSubmit={handleUpdate}>
                  <div className="mb-3"><label className="form-label" htmlFor="edit-ban-image">Image</label><input id="edit-ban-image" type="file" className="form-control" accept="image/*" onChange={(e) => handleUpload(e, true)} disabled={uploading} /></div>
                  <div className="mb-3"><label className="form-label" htmlFor="edit-ban-description">Description</label><textarea id="edit-ban-description" name="description" className="form-control" value={editForm.description} onChange={handleEditInputChange} /></div>
                  <div className="mb-3"><label className="form-label" htmlFor="edit-ban-redirect">Redirect URL</label><input id="edit-ban-redirect" name="redirectUrl" className="form-control" value={editForm.redirectUrl} onChange={handleEditInputChange} /></div>
                  <div className="row">
                    <div className="col-md-6 mb-3"><label className="form-label" htmlFor="edit-ban-order">Display Order</label><input id="edit-ban-order" name="displayOrder" type="number" min="1" className="form-control" value={editForm.displayOrder} onChange={handleEditInputChange} /></div>
                    <div className="col-md-6 mb-3 d-flex align-items-end"><div className="form-check"><input id="edit-ban-enabled" name="enabled" type="checkbox" className="form-check-input" checked={!!editForm.enabled} onChange={handleEditInputChange} /><label className="form-check-label" htmlFor="edit-ban-enabled">Enabled</label></div></div>
                  </div>
                  <div className="d-flex justify-content-end gap-2"><button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={isUpdating}>Cancel</button><button type="submit" className="btn btn-primary" disabled={uploading || isUpdating}>{isUpdating ? 'Saving...' : 'Save Changes'}</button></div>
                </form>
              </div>
            </div></div>
          </div>

          {/* View Banner Modal */}
          <div className="modal fade" id="viewBanner" tabIndex="-1" aria-labelledby="viewBannerLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="viewBannerLabel">Banner Details</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setViewBanner(null)}></button></div>
              <div className="modal-body px-4">
                {viewBanner ? (
                  <div>
                    <div className="mb-3">{viewBanner.imageUrl ? <img src={viewBanner.imageUrl} alt="banner" style={{ width: '100%', maxHeight: 240, objectFit: 'cover' }} /> : <span className="text-muted">No image</span>}</div>
                    <div className="mb-2"><strong>Description:</strong><div className="text-muted">{viewBanner.description || '-'}</div></div>
                    <div className="mb-2"><strong>Redirect URL:</strong> {viewBanner.redirectUrl ? <a href={viewBanner.redirectUrl} target="_blank" rel="noreferrer">{viewBanner.redirectUrl}</a> : <span className="text-muted">-</span>}</div>
                    <div className="mb-2"><strong>Enabled:</strong> {viewBanner.enabled ? 'Yes' : 'No'}</div>
                    <div className="mb-2"><strong>Display Order:</strong> {viewBanner.displayOrder}</div>
                    <div className="mb-2"><strong>Created At:</strong> {viewBanner.createdAt ? new Date(viewBanner.createdAt).toLocaleString() : '-'}</div>
                    <div className="mb-2"><strong>Updated At:</strong> {viewBanner.updatedAt ? new Date(viewBanner.updatedAt).toLocaleString() : '-'}</div>
                  </div>
                ) : (
                  <div className="text-muted">No banner selected</div>
                )}
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setViewBanner(null)}>Close</button></div>
            </div></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banners;
